import api from "@/components/customAxios/Axios";
import { useToast } from "./toast";

const GoogleAuth = () => {
	const toast = useToast();

	const handleGoogleAuth = async () => {
		try {
			const response = await api.post(
				"/google_login",
				{}, // Empty JSON body
				{
					headers: {
						"Content-Type": "application/json",
					},
					withCredentials: true,  // Send cookies with the request
				}
			);
			if (response.status === 200) {
				window.location.assign(response.data.authorization_url);
			}
		} catch (error: any) {
			toast.error({
				type: "background",
				duration: 3000,
				status: "error",
				title: "Authentication Error",
				description: error.response?.data?.error || error.response?.data?.message || "Failed to authenticate with Google. Please try again.",
				open: true,
			});

		}
	};

	return (
		<div>
			{/* OR Divider */}
			<div className="flex items-center my-4">
				<div className="flex-grow border-t border-zinc-300 dark:border-zinc-600"></div>
				<span className="px-3 text-zinc-700 dark:text-zinc-300 text-sm font-medium">
					OR
				</span>
				<div className="flex-grow border-t border-zinc-300 dark:border-zinc-600"></div>
			</div>

			<button
				type="button"
				onClick={handleGoogleAuth}
				className="w-full flex items-center justify-center bg-[#F3F9FA]  font-semibold py-3 px-4 rounded-lg  hover:bg-gray-100 dark:hover:bg-zinc-600 transition"
			>
				<img
					src="https://www.svgrepo.com/show/355037/google.svg"
					alt="Google logo"
					className="h-5 w-5 mr-2"
				/>
				Continue with Google
			</button>
		</div>
	);
};

export default GoogleAuth;
